export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-partner-head-distributor',

  employersCountLabel: 'partnerbasicinfo-employers-count-distributor',
  totalSalesLabel: 'total-sales',
  hpDedicatedSalesLabel: 'hpdedicated-sales',
}
